import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {SubmitTicketIssueDto, TicketIssueDto, TicketIssuePreviewDto} from "@server-models";
import {SharedIssueApiService} from "@shared/components/issues/services/shared-issue-api.service";
import {IIssueService} from "@shared/components/issues/interfaces/issue-service.interface";

@Injectable({
  providedIn: 'root',
})
export class TechIssueTicketApiService extends SharedIssueApiService implements IIssueService {

  getIssuePreview(templateId: number): Observable<TicketIssuePreviewDto> {
    return super.get<TicketIssuePreviewDto>(`/tech/v2/issue/ticket/template/${ templateId }/preview`, undefined);
  }

  getIssue(issueId: number): Observable<TicketIssueDto> {
    return super.get<TicketIssueDto>(`/tech/v2/issue/ticket/${ issueId }`);
  }

  sendIssueTemplatePreviewById(templateId: number, issue: SubmitTicketIssueDto): Observable<void> {
    return super.post<void>(`/tech/v2/issue/ticket/template/${ templateId }/submitIssue`, undefined, issue)
  }
}
